
import xss from "xss";
import Price from "../type/price";
import CONFIG from "../config";

export class BasketStorage {
  constructor() {
    this.warenkorbId = null;
    this.orderData = [];
    this.orderDataForOrder = [];
    this.locked = false;
    this.dirty = false;
    this.editCondition = false;
    this.sum = Price.create(0);
    this.items = [];
    this.shipping = Price.create(0);
    this.checkSum = Price.create(0);
    this.dues = Price.create(0);
    this.duesPercentage = 0;
    this.duesAmount = 0;
    this.positionDuesSum = Price.create(0);
    this.doShip = "no";
    this.shippingCosts = 0;
    this.maxShipment = 0;
    this.maxSum = 100000;
    this.filialen = [];
    this.selectedFiliale = null;
    this.hasDues = false;
    this.hasShippingChoice = true;
    this.isAnkaufShop = false;
    this.sumLessthanMinOdervalueFiliale = false;
    this.error = {
      message: null
    };
    this.bankApiResponseData = null;
    this.gebuehren = {};    
    this.orderLimit = null;
    this.mandantStorage = null;
  }

  removeItem(id) {
    if (this.locked) return;
    this.items = this.items.filter(item => item.id !== id);
    if (this.items.length === 0) {
      this.setClean();
    }
    this.updateSum();
  }

  updateSum() {
    console.log("dummy for item function");
  }

  setDoShip() {
    console.log("dummy for doShip");
  }

  numItems() {
    return this.items.length;
  }

  getFilialen(isKundenShop = true) {
    return this.filialen
      .map((f) => {
        const filiale = { ...f };
        if (!isKundenShop) {
          filiale.name = f.beraterName || f.name;
        }
        filiale.address = filiale.name;
        delete filiale.beraterName;
        return filiale;
      })
      .filter((f) => f.maxBetrag >= this.sum.getPrice() || this.isAnkaufShop)
      .sort((a, b) => {
        // sort by lieferadressenNummer (numeric). This is stored as `value` in `setBaseMasterData`.
        const aNum = Number(a.value);
        const bNum = Number(b.value);
        if (isNaN(aNum) && isNaN(bNum)) return 0;
        if (isNaN(aNum)) return 1;
        if (isNaN(bNum)) return -1;
        return aNum - bNum;
      });
  }

  hasFilialen() {
    //console.info("BasketStorage - check hasFilialen - isAnkaufShop: ", this.isAnkaufShop, "filialen:", this.filialen.length);
    if (this.isAnkaufShop) {
      return this.filialen.length > 0;
    } else {
      const currentSum = this.sum.getPrice();
      const hasMatchingFiliale = this.filialen.filter(f => f.maxBetrag >= currentSum).length > 0;
      const minOrderValueFiliale = this.mandantStorage && typeof this.mandantStorage.getMinOrdervalueFiliale === "function"
        ? Number(this.mandantStorage.getMinOrdervalueFiliale())
        : 0;

      return hasMatchingFiliale && currentSum >= minOrderValueFiliale;
    }
  }

  setCurrentShopIsAnkauf(isAnkaufShop) {
    this.isAnkaufShop = !!isAnkaufShop;
    if (this.hasFilialen() && this.isAnkaufShop) this.selectedFiliale = this.filialen[0];
    if (this.isAnkaufShop) {
      this.recalcLimits();
    }
  }

  getMaxBasketSize() {
    if (this.isAnkaufShop) {
      return 1;
    } else {
      return CONFIG.MAX_BASKET_ITEMS;
    }
  }

  isBasketFull() {
    if (this.isAnkaufShop) {
      return this.items.length >= 1;
    } else {
      return this.items.length >= CONFIG.MAX_BASKET_ITEMS;
    }
  }

  setWarenkorbId(id) {
    this.warenkorbId = xss(id);
  }

  setDataForOrder(data) {
    // clone data
    try {
      this.orderDataForOrder = JSON.parse(JSON.stringify(data)) || [];
    } catch (e) {
      this.orderDataForOrder = [];
    }
  }

  getShippingCosts() {
    return Price.create(this.shippingCosts);
  }

  calcShippingChoice() {
    this.hasShippingChoice = this.checkSum.getPrice() <= this.maxShipment;

    if(!this.isAnkaufShop) {
      const minOrderValueFiliale = this.mandantStorage && typeof this.mandantStorage.getMinOrdervalueFiliale === "function"
          ? Number(this.mandantStorage.getMinOrdervalueFiliale())
          : 0;
      this.sumLessthanMinOdervalueFiliale = this.checkSum.getPrice() < minOrderValueFiliale;
    }
  }

  calcInnenProvision() {
    return 0; // overwritten in sortenBasket and edelmetallBasket
  }

  getDataForOrder() {
    let dataForOrder = {
      orderData: this.orderDataForOrder,
      selectedFiliale: this.hasFilialChoice ? this.selectedFiliale : null,
      doShip: this.doShip,
      gebuehren: this.gebuehren || {}
    };
    return dataForOrder;
  }

  getDataForCart() {
    let dataForCart = {
      orderData: this.orderData,
      selectedFiliale: this.hasFilialChoice ? this.selectedFiliale : null,
      doShip: this.doShip,
      gebuehren: this.gebuehren || {}
    };
    return dataForCart;
  }

  // used to add the dues when calculating the max-sum, only add dues if this is the first price
  getPriceWithDues(price) {
    if (isNaN(price) || price === 0) return 0;
    if (this.hasDues && this.items.length === 0)
      return price + this.dues.getPrice();
    return price;
  }

  setBaseMasterData(data) {
    this.filialen = [];
    if (!data || !Array.isArray(data.listLieferdaten)) return;
    const definedOrEmpty = (s) => s ? xss(String(s)) : "";
    this.filialen = data.listLieferdaten.map(item => {
      const maxBetrag = !isNaN(item.maxBetrag) ? Math.min(this.maxSum, Number(item.maxBetrag)) : this.maxSum;

      return {
        value: Number(item.lieferadressenNummer),
        name: xss(String(item.bezeichnung)),
        address: [
          xss(definedOrEmpty(item.lieferadresseName1) + " " + definedOrEmpty(item.lieferadresseName2)),
          xss(definedOrEmpty(item.lieferadresseStrasse1) + " " + definedOrEmpty(item.lieferadresseStrasse2)),
          definedOrEmpty(item.lieferadresse_plz),
          definedOrEmpty(item.lieferadresseOrt)
        ].filter(s => s.trim() > "").join(", "),
        maxBetrag,
        beraterName: xss(definedOrEmpty(item.lieferadresseStrasse1)),
      };
    });
  }

  updateData(data) {
    console.log("dummy updateData", data);
  }

  lock() {
    this.locked = true;
    if (Array.isArray(this.items)) this.items.forEach(item => item.locked = true);
  }

  unlock() {
    this.locked = false;
    if (Array.isArray(this.items)) this.items.forEach(item => item.locked = false);
  }

  isLocked() {
    return this.locked;
  }

  isEmpty() {
    return this.items.length === 0;
  }

  getMaxSum() {
    if (this.isAnkaufShop) {
      return this.maxSum;
    }
    
    return Math.min(this.maxSum, this.filialen.reduce((prev, f) => Math.max(prev, f.maxBetrag), this.maxShipment));
  }

  isPriceTooHigh(price) {
    const maxBetrag = this.getMaxSum();
    if (maxBetrag === null || isNaN(maxBetrag)) return false;
    return price > maxBetrag;
  }

  isTooHigh() {
    return this.isPriceTooHigh(this.sum.getPrice());
  }

  isTooHighForSell() {
    // Override in subclass
  }
  
  isSumTooHigh(price) {
    return this.isPriceTooHigh(
      this.getPriceWithDues(price) + this.sum.getPrice()
    );
  }

  isOverOrderLimit () {
    if ( this.numericLimit !== null && !isNaN(this.numericLimit) && this.sum.getPrice() > this.numericLimit ) { 
      return true;
    } else {
      return false;
    }
  }

  resolveSellOrderLimit(state) {    
    const orderLimitObj = state.mandantStorage.getOrderLimit();
    if (!orderLimitObj) return null;

    const { configStorage, rightStorage } = state;
    const isAnkauf = configStorage.isAnkaufShop();
    const isInternetFiliale = configStorage.isKundenShop();
    const isBerater1 = rightStorage.isBerater1();
    const isBerater2 = rightStorage.isBerater2();
    const isCallcenter = rightStorage.isDeubaCallcenter() || rightStorage.isVerseNeoServicecenter();

    let resolvedOrderLimit = null;
    if (isInternetFiliale) {
      resolvedOrderLimit = orderLimitObj.ifSell;
    } else if (!isAnkauf) {
      if (isCallcenter) {
        resolvedOrderLimit = orderLimitObj.callCenterSell;
      } else if (isBerater1) {
        resolvedOrderLimit = orderLimitObj.berater1Sell;
      } else if (isBerater2) {
        resolvedOrderLimit = orderLimitObj.berater2Sell;
      } 
    } else {
      if (isCallcenter) {
        resolvedOrderLimit = orderLimitObj.callCenterBuy;
      } else if (isBerater1) {
        resolvedOrderLimit = orderLimitObj.berater1Buy;
      } else if (isBerater2) {
        resolvedOrderLimit = orderLimitObj.berater2Buy;
      } 
    }
    
    //console.log("resolveSellOrderLimit - resolvedOrderLimit:", resolvedOrderLimit);

    return  resolvedOrderLimit === null ? null : Number(resolvedOrderLimit);

  }  

  getMaxSumText() {
    const maxBetrag = this.getMaxSum();
    return Price.markify(maxBetrag);
  }

  getMaxShipmentText() {
    return Price.markify(this.maxShipment.valueOf());
  }

  getMaxBetragText() {
    const maxBetrag = this.filialen.reduce((prev, f) => Math.max(prev, f.maxBetrag), this.maxShipment);
    return Price.markify(maxBetrag.valueOf());
  }

  isDirectOrder() {
    return (
      !this.isAnkaufShop &&
      this.sum.getPrice() <= this.maxShipment &&
      this.doShip === "yes" &&
      this.items.length > 0
    );
  }

  resetBaseWarenkorb() {
    this.shipping = Price.create(0);
    this.dues = Price.create(0);
    this.items = [];
    this.sum = Price.create(0);
    this.doShip = "no";
  }

  setSelectedFiliale(filiale) {
    if (typeof filiale === "object") {
      this.selectedFiliale = filiale;
    } else {
      this.selectedFiliale = this.filialen.find(f => Number(f.value) === Number(filiale)) || null;
    }
    if (this.selectedFiliale !== null) {
      this.selectedFiliale = { ...this.selectedFiliale };
      delete this.selectedFiliale.beraterName;
      this.setDoShip("no");
    }
  }

  setError(msg) {
    this.error.message = msg;
  }

  isError() {
    return !!this.error.message;
  }

  getError() {
    return this.error.message;
  }

  findInListByProp(list, prop, compare) {
    if (!list || !Array.isArray(list)) return null;
    return list.find(item => item[prop] === compare) || null;
  }

  setClean() {
    this.items.forEach(item => {
      item.dirty = false;
    });
    this.dirty = false;
  }

  isDirty() {
    return this.dirty === true;
  }

  restoreBaseData(data) {
    this.warenkorbId = xss(data.warenkorbId);
    this.setDoShip(data.doShip);
    this.selectedFiliale = data.selectedFiliale;
    this.setDataForOrder(data.orderDataForOrder);
  }

  getBankApiResponseData() {
    return this.bankApiResponseData ? this.bankApiResponseData : { bankApiRespons: "" };
  }

  setBankApiResponseData(bankApiResponseData) {
    if (typeof bankApiResponseData !== "object") return;
    this.bankApiResponseData = {};
    this.bankApiResponseData.bankApiResponse = xss(bankApiResponseData.bankApiResponse);
  } 

  setOrderLimit(state) {
    this.mandantStorage = state && state.mandantStorage ? state.mandantStorage : null;
    this.orderLimit = this.resolveSellOrderLimit(state);
    this.recalcLimits();
  }

  getOrderLimit(){
    return this.orderLimit;
  }

  recalcLimits() {
    // Override in subclass
  }

  clone() {
    const clone = Object.create(Object.getPrototypeOf(this));
    Object.assign(clone, this);
    return clone;
  }
}
